import React from 'react';
import { FiX } from "react-icons/fi";

const FeesStudentsList = ({
  studentList,
  handleStudentSelection,
  handleSendFees,
  closeStudentList,
  arr,
  setArr,
}) => {
 
    const handleToggleStudent = (studentId) => {
        const index = arr.indexOf(studentId);
        if (index === -1) {
          // Student ID not in arr, add it
          setArr([...arr, studentId]);
        } else {
          // Student ID in arr, remove it
          const newArr = [...arr];
          newArr.splice(index, 1);
          setArr(newArr);
        }
      };
    
  return (
    <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-black bg-opacity-50 z-50 overflow-y-auto p-4 pt-24">
      <div className="bg-white rounded-lg shadow-lg p-4 mt-5 w-full max-w-md">
        <div className="flex justify-end mb-4">
          <button
            onClick={closeStudentList}
            className="text-gray-500 hover:text-gray-800 focus:outline-none"
          >
            <FiX className="h-6 w-6" />
          </button>
        </div>
        <h2 className="text-2xl font-bold mb-2">Student List</h2>   
          <ul className="divide-y divide-gray-200">
          {studentList.map((student) => {
              const isStudentSelected = arr.includes(student.id); // Check if the student is selected
              return (
                <li
                  key={student.id}
                  className={`pt-2 mb-2 cursor-pointer ${isStudentSelected ? 'text-green-500' : ''}`} // Change text color if selected
                  onClick={() =>
                    handleToggleStudent(student.id)
                  }
                 
                >
                  <p>{student.name}</p>
                </li>
              );
            } 
          )}
        </ul>
        <div className="flex justify-center mt-5">
          <button
            type="button"
            className="bg-gray-300 hover:bg-gray-400 text-bold px-9 py-2 rounded-full focus:outline-none cursor-pointer"
            onClick={handleSendFees} // This triggers the Fees submission
          >
            Submit Fees
          </button>
        </div>
      </div>
    </div>
  );
};

export default FeesStudentsList;
